import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import FieldInfo from 'app/common/components/field-info';
import Widget from 'app/common/components/widgets/widget';
import type { EnumWidgetHookProps } from './enum-widget-hook.js';

export function EnumInput({
  label,
  error,
  options,
  value,
  isRequired,
  disabled,
  readOnly,
  handleChange,
  description,
  id
}: EnumWidgetHookProps) {
  return (
    <FormControl fullWidth variant="outlined" error={Boolean(error)} required={isRequired} disabled={disabled}>
      <InputLabel id={id} size="small">
        {label}
      </InputLabel>
      <Select
        size="small"
        labelId={id}
        label={label}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        readOnly={readOnly}
        error={Boolean(error)}
        required={isRequired}
        inputProps={{
          'data-testid': `${id}__select`
        }}
      >
        {options.map(({ value, label }) => (
          <MenuItem key={value} value={value} data-testid={`${id}__option-${value}`}>
            {label}
          </MenuItem>
        ))}
      </Select>
      <FieldInfo description={description} error={error} />
    </FormControl>
  );
}

export function EnumWidget(props: EnumWidgetHookProps) {
  return (
    <Widget testId={props.id}>
      <EnumInput {...props} />
    </Widget>
  );
}
